import React from "react";
import { graphql } from "gatsby";
import Mustache from "mustache";
const template = require("./email.html");
const footer = require("./footer.html");

import Newsletter from "~/models/newsletter";

type Props = {
  data: any;
};

const NewsletterPage = ({ data }: Props) => {
  const newsletter = new Newsletter(data.newsletter as any);

  var content: any = {
    date: newsletter.date,
    featured: {
      title: newsletter.featured.title,
      url: newsletter.featured.url.pathname,
      image: `${newsletter.featured.imageUrls?.thumbnail?.publicURL}`,
      description: newsletter.featured.description,
    },
    articles: [],
    news: [],
    currentYear: new Date().getFullYear(),
  };

  newsletter.articles.forEach((article: any, index: number) => {
    content.articles.push({
      title: article.title,
      url: article.url.pathname,
      image: `${article.imageUrls?.thumbnail?.publicURL}`,
      last: index + 1 == newsletter.articles.length,
    });
  });

  newsletter.news.forEach((news: any, index: number) => {
    content.news.push({
      title: news.title,
      url: news.url.pathname,
      image: `${news.imageUrls?.thumbnail?.publicURL}`,
      last: index + 1 == newsletter.news.length,
    });
  });

  var tmpl: any = template.default;

  tmpl = tmpl.replace(
    /<title>(.|\n)*?<\/title>/gm,
    "<title>{{featured.title}}</title>"
  );

  tmpl = tmpl.replace(
    /<!-- BEGIN Footer -->(.|\n)*?<!-- END Footer -->/gm,
    footer.default
  );

  var html = Mustache.render(tmpl, content);

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default NewsletterPage;

export const query = graphql`
  query NewsletterPage($id: String) {
    newsletter: newsletterYaml(id: { eq: $id }) {
      id
      date
      featured {
        id
        frontmatter {
          id
          title
          type
          url {
            yamlId
            name
            pathname
          }
          labels {
            yamlId
            name
            slug
            description
          }
          releasedAt
          updatedAt
          description
          image {
            ...AssetFields
          }
        }
        excerpt
      }
      articles {
        id
        frontmatter {
          id
          title
          type
          url {
            yamlId
            name
            pathname
          }
          labels {
            yamlId
            name
            slug
            description
          }
          releasedAt
          updatedAt
          description
          image {
            ...AssetFields
          }
        }
        excerpt
      }
      news {
        id
        frontmatter {
          id
          title
          type
          url {
            yamlId
            name
            pathname
          }
          labels {
            yamlId
            name
            slug
            description
          }
          releasedAt
          updatedAt
          description
          image {
            ...AssetFields
          }
        }
        excerpt
      }
    }
  }
`;
